import React from 'react';
import FeatureToggleUtils from 'FeatureToggleUtils';
import classnames from 'classnames';
import {
    isSessionStartsInMorethan,
    isSessionEnded,
    loadSessionPage,
    isSessionLive,
    PRE_SESSION_LIVE_TIME,
    isSessionEndedMoreThan,
    SESSION_GRACE_TIME,
} from '../../sessionBroadcastUtils';
import JoinLiveSessionButton from '../../JoinLiveSessionButton';
import LiveBroadcastLabel from '../../LiveBroadcastLabel';
import WatchRecordingButton from '../../VirtualSessions/WatchRecordingButton';
import WatchExternalOnDemandSessionButton from '../../WatchExternalOnDemandSessionButton';
import { loginClickOrigin } from '../../../../../constants/Enums';

export default function JoinBroadcastButtonPreview({
    eventUrls,
    session,
    me,
    showEmailLogin,
    sessionViewType,
    event,
    setVirtualSessionDetails,
    siteConf,
    setScrollToSessionBroadcastAction,
    setRecordUrl,
    showRegisterAndLoginModal,
    ticketsSelectionData,
    setLoginV2OffsetTop,
}) {
    const isExternalOnDemand = session?.recordingSession?.recordingPrimaryAssetType === 'EXTERNAL';
    const { enableVirtualSession } = session || {};
    const isFeatureSessionVirtualElementEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');
    const shouldRender =
        sessionViewType === 'sessionPreviewWindow' &&
        (
            (isFeatureSessionVirtualElementEnabled && enableVirtualSession)
            ||
            isExternalOnDemand
        );

    if (!shouldRender) return null;

    const isAuthenticated = !!(me && me.id);
    const timeZone = event && event['time-zone-id'];
    const isSessionOver = isSessionEnded(session, timeZone);
    const isSessionInMoreThanPreliveTime = isSessionStartsInMorethan(session, PRE_SESSION_LIVE_TIME, timeZone);
    const isSessionLiveNow = isSessionLive(session, timeZone);
    const enableRecordingSession = session.enableRecordingSession;
    const color = siteConf?.color1 || '';
    const containerClasses = classnames('preview-view-join-broadcast-button', {
        'margin-bottom-small': !session.locationId,
        'margin-bottom-xs': session?.locationId
    });
    const eventStartDate = event && event['start-date'];
    const eventStarted = Date.now() > eventStartDate;
    const sessionIsUnscheduled = !session.startDate;
    const isSessionPassedGraceTime = sessionIsUnscheduled || isSessionEndedMoreThan(session, SESSION_GRACE_TIME, timeZone);
    const { recordingIsReady = false, broadcastRecording = false } = session.recordingSession ?? {};
    const recordingOrOnDemandAvailable = (isSessionOver || (eventStarted && sessionIsUnscheduled)) &&
        enableRecordingSession &&
        broadcastRecording &&
        recordingIsReady;
    const showWatchRecordingButton =
        recordingOrOnDemandAvailable &&
        enableVirtualSession &&
        isSessionOver;
    const showOnDemandButton = recordingOrOnDemandAvailable && !enableVirtualSession && (isSessionOver || sessionIsUnscheduled);
    const onDemandButtonText = showWatchRecordingButton ? 'Watch Recording' : (sessionIsUnscheduled ? 'Watch On Demand' : 'Watch Session');
    const sessionRecordingNotReady = !broadcastRecording || !recordingIsReady;

    return (
        <div className={containerClasses}>
            {
                isSessionLiveNow &&
                    <JoinLiveSessionButton
                        event={event}
                        me={me}
                        session={session}
                        eventUrls={eventUrls}
                        showEmailLogin={showEmailLogin}
                        setVirtualSessionDetails={setVirtualSessionDetails}
                        setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
                        btnText="Join Session"
                        setRecordUrl={setRecordUrl}
                        showRegisterAndLoginModal={showRegisterAndLoginModal}
                        siteConf={siteConf}
                        analyticData={{
                            clickOrigin: loginClickOrigin.sessionPreview.join('Join Broadcast'),
                            sessionId: session?.id,
                        }}
                    />
            }
            {
                isSessionInMoreThanPreliveTime &&
                <LiveBroadcastLabel
                    color={color}
                    label="Broadcast"
                    additionalText={`Starts ${PRE_SESSION_LIVE_TIME} min before the session time`}
                />
            }
            {
                isSessionOver &&
                !enableRecordingSession &&
                <LiveBroadcastLabel
                    label="Broadcast has ended"
                    color={color}
                />
            }
            {
                (
                    enableRecordingSession && sessionRecordingNotReady && ((isSessionOver && !isSessionPassedGraceTime) ||
                        (eventStarted && sessionIsUnscheduled))
                ) &&
                <LiveBroadcastLabel
                    label="Broadcast has ended"
                    additionalText="Recording will be ready soon"
                    color={color}
                />
            }
            {
                (showWatchRecordingButton || showOnDemandButton) && !isExternalOnDemand &&
                <WatchRecordingButton
                    onClick={() => loadSessionPage({ event, sessionId: session.id })}
                    isAuthenticated={isAuthenticated}
                    eventUrls={eventUrls}
                    showEmailLogin={showEmailLogin}
                    showRegisterAndLoginModal={showRegisterAndLoginModal}
                    isWidget={siteConf?.isWidget}
                    eventName={event?.name}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    text={onDemandButtonText}
                    analyticData={{
                        clickOrigin: loginClickOrigin.sessionPreview.join(onDemandButtonText),
                        sessionId: session?.id,
                    }}
                />
            }
            { (showWatchRecordingButton || showOnDemandButton) && isExternalOnDemand &&
            <WatchExternalOnDemandSessionButton
                event={event}
                eventUrls={eventUrls}
                me={me}
                session={session}
                showRegisterAndLoginModal={showEmailLogin}
                showEmailLogin={showEmailLogin}
                ticketsSelectionData={ticketsSelectionData}
                btnText={onDemandButtonText}
                btnClass={'external-solution-btn'}
                siteConf={siteConf}
                analyticData={{
                    clickOrigin: loginClickOrigin.sessionPreview.join(onDemandButtonText),
                    sessionId: session?.id,
                }}
            />}
        </div>
    );
}
